import { createTheme } from '@mui/material/styles'
import { renderTimeViewClock } from '@mui/x-date-pickers'

const palette = {
  background: {
    default: '#e6e6e6',
    card: '#fafafa',
    grey1: 'rgba(236,239,241,.38)',
    menu: '#051e34',
  },
  grey: {
    100: '#fafafa',
    200: '#f5f5f5',
    300: '#f0f0f0',
    400: '#ebebeb',
    500: '#e6e6e6',
    600: '#b8b8b8',
    700: '#8a8a8a',
    800: '#5c5c5c',
    900: '#2e2e2e',
  },
  primary: {
    light: '#4197D1',
    main: '#2A79AC',
    dark: '#1D5479',
    divider: 'rgb(42, 72, 101)',
  },
  secondary: {
    light: '#EE6084',
    main: '#EA3B66',
    dark: '#B8133D',
  },
  tertiary: {
    light: '#E7A567',
    main: '#E18D40',
    dark: '#B0631B',
  },
}

const theme = createTheme({
  palette,
  typography: {
    useNextVariants: true,
    fontFamily: 'Roboto',
    h1: {
      fontSize: '4rem',
      marginBottom: '2rem',
    },
    h2: {
      fontSize: '2rem',
    },
    h5: {
      fontWeight: 500,
      fontSize: 26,
      letterSpacing: 0.5,
    },
    subtitle1: {
      color: 'rgba(0, 0, 0, 0.54)',
    },
    body1: {
      fontSize: '1rem',
    },
    body2: {
      fontSize: '1rem',
    },
  },
  shape: {
    borderRadius: 8,
  },
  mixins: {
    toolbar: {
      minHeight: 48,
    },
  },
  components: {
    MuiAvatar: {
      root: {
        width: 32,
        height: 32,
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          minWidth: 40,
        },
        label: {
          textTransform: 'none',
        },
        contained: {
          boxShadow: 'none',
          '&:active': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiDesktopDateTimePicker: {
      defaultProps: {
        viewRenderers: {
          hours: renderTimeViewClock,
          minutes: renderTimeViewClock,
          seconds: renderTimeViewClock,
        },
      },
    },
    MuiDesktopTimePicker: {
      defaultProps: {
        viewRenderers: {
          hours: renderTimeViewClock,
          minutes: renderTimeViewClock,
          seconds: renderTimeViewClock,
        },
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: '#404854',
      },
    },
    MuiDrawer: {
      paper: {
        backgroundColor: '#18202c',
      },
    },
    MuiGrid: {
      defaultProps: {
        spacing: 1,
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
          cursor: 'pointer',
        },
      },
    },
    MuiListItemText: {
      primary: {
        fontWeight: 500,
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          '&:before': {
            borderBottom: 'none',
          },
          '&:hover:not(.Mui-disabled, .Mui-error):before': {
            borderBottom: 'none',
          },
          ':hover': {
            opacity: .5,
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          margin: '0 16px',
          minWidth: 0,
          padding: 0,
        },
      },
    },
    MuiTabs: {
      indicator: {
        height: 3,
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        backgroundColor: '#ffffff',
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: 8,
        },
      },
    },
    MuiTooltip: {
      tooltip: {
        borderRadius: 4,
      },
    },
  },
})

export default theme
